import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Notes } from 'libs/portal/src/models/Notes';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { TitleService } from 'libs/portal/src/services/title/title.service';
import { UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { Endpoints } from '@huge-monorepo/portal/config';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
})
export class ChatComponent implements OnInit {
  deviceId: number;
  deviceNotes: Notes[] = [];
  userId = 0;
  newNote = '';
  showSpinner = false;

  formGroup: UntypedFormGroup = new UntypedFormGroup({
    searchControl: new UntypedFormControl('', []),
  });

  constructor(
    private titleService: TitleService,
    private activatedRoute: ActivatedRoute,
    private genericService: GenericService,
    private auth: UserRightsService,
    private endpoints: Endpoints,
  ) {}

  ngOnInit() {
    this.titleService.pageTitle = 'Device Notes';
    this.activatedRoute.paramMap.subscribe((params) => {
      this.deviceId = parseInt(params.get('id'));
    });
    this.getNotes();
    this.userId = this.auth.GetUID();
  }

  async getNotes() {
    if (this.deviceId != null) {
      this.genericService.GET(this.endpoints.GET_NOTES(this.deviceId, false, '', false)).subscribe((resp: Object) => {
        this.deviceNotes = resp['body'] != null ? resp['body'].reverse() : [];
      });
    }
  }

  searchNotes() {
    const searchTerm = this.formGroup.get('searchControl').value;
    if (searchTerm == '') {
      this.getNotes();
    } else {
      if (this.deviceId != null) {
        this.genericService.GET(this.endpoints.SEARCH_NOTES(this.deviceId, false, '', searchTerm, false)).subscribe((resp: Object) => {
          this.deviceNotes = resp['body'] != null ? resp['body'].reverse() : [];
        });
      }
    }
  }

  addNote() {
    const note = {
      Message: this.newNote,
      DeviceID: this.deviceId,
    };

    this.genericService.POST(this.endpoints.ADD_NOTE(this.deviceId, false), note, true).subscribe((resp: any) => {
      this.deviceNotes.push(resp['body']);
    });

    this.newNote = '';
  }
}
